export default "__VITE_ASSET__B9jZCTOp__"